import {
    UpdateShouldShowSimplifiedBDUIAction,
    updateShouldShowSimplifiedBdUISuccess,
    UpdateUserDevicesAction,
    updateUserDevicesSuccess,
    UpdateUserEmailNotificationSettingsAction,
    updateUserEmailNotificationSettingsSuccess,
    VerifyCommsUserAction,
    verifyCommsUserSuccess,
} from './../actions/user';
import {
    archiveBuildDistributionBucketSuccess,
    ArchiveBuildDistributionBucketSuccessResponse,
    FetchBuildDistributionBucketBuildResponsePayload,
    fetchBuildDistributionBucketBuildSuccess,
    newBuildDistributionBucketSuccess,
    NewBuildDistributionBucketSuccessResponse,
    ShareBuildDistributionBuildWithTestersAction,
    shareBuildDistributionBuildWithTestersSuccess,
    ShareBuildDistributionBuildWithTestersSuccessResponse,
    TRIGGER_BUILD_DISTRIBUTION_BUILD,
    TriggerBuildDistributionBuildAction,
    TRY_ARCHIVE_BUILD_DISTRIBUTION_BUCKET,
    TRY_NEW_BUILD_DISTRIBUTION_BUCKET,
    TryArchiveBuildDistributionBucketAction,
    TryUpdateBuildDistributionBucketAction,
    UPDATE_BUILD_DISTRIBUTION_BUILD_TESTER_NOTES,
    UPDATE_BUILD_DISTRIBUTION_BUILD_TESTERS,
    UpdateBuildDistributionBucketSuccessResponse,
    UpdateBuildDistributionBuildTesterNotesAction,
    updateBuildDistributionBuildTesterNotesSuccess,
    UpdateBuildDistributionBuildTesterNotesSuccessResponse,
    updateDistributionBucketsSuccess,
    updateDistributionBucketSuccess,
    ArchiveBuildDistributionBuildAction,
    archiveBuildDistributionBuildSuccess,
    ArchiveBuildDistributionBuildSuccessResponse,
    ARCHIVE_BUILD_DISTRIBUTION_BUILD,
} from './../actions/buildDistribution';
import {
    FetchFeatureFlagsResponse,
    TryUpdateFeatureFlagsAction,
    updateFeatureFlagsForReleases,
    updateFeatureFlagsSuccess,
} from './../actions/featureFlags';
import * as Analytics from '../utils/analytics';
import { AppProperties } from '../utils/analytics';
import {
    AuthCredentials,
    BuildDistroBucketBase,
    BuildDistroBuild,
    FeatureFlag,
    GetAllDevicesResponse,
    NonErrorRunwayResponseTypes,
    ReleaseStep,
    RolloutMonitoring,
    RunwayModelsResponse,
    RunwayResponseType,
    RunwayResponseV2,
} from './../types';
import { all, delay, put, select, spawn, takeEvery, takeLatest, takeLeading } from 'redux-saga/effects';
import {
    logoutSuccess,
    TRY_LOGIN,
    TRY_LOGOUT,
    TRY_VERIFY_AUTH_CODE,
    TryLoginAction,
    TryLogoutAction,
    TryVerifyAuthCodeAction,
} from '../actions/login';
import * as Sentry from '@sentry/react';
import {
    AllStateUpdateEventModelTypes,
    App,
    AppGroup,
    AppSettings,
    DashboardState,
    Environment,
    ModelType,
    Notification,
    OrganizationEntity,
    Release,
    ReleaseStepType,
    User,
    WebsocketEventContainer,
    WebsocketMessageType,
    WebsocketNewStateEvent,
    WebsocketNotificationEvent,
    WebsocketStateUpdateEvent,
} from '../types';
import * as API from '../api';
import { RunwayResponseError } from '../api';
import {
    AddAppsAction,
    appEntityUpdated,
    APPS_ADDED_SUCCESS,
    appsAddedSuccess,
    appsDeleted,
    appsUpdated,
    ConnectedAppEntityResponse,
    CreateAppAction,
    DeletedAppEntityPayload,
    TRY_ADD_APPS,
    TRY_CREATE_APP,
    TRY_DELETE_APP_ENTITY,
    TryDeleteAppAction,
} from '../actions/app';
import {
    ConnectedReleaseResponse,
    deleteReleaseEntity,
    DeleteReleaseEntityPayload,
    deleteReleasesTriggeredFromWebsocket,
    NEW_RELEASE_SUCCESS,
    newReleaseSuccessAction,
    releasesUpdated,
    TRIGGER_RELEASE_WORKFLOW_BUILD,
    TriggerReleaseWorkflowBuildAction,
    TRY_DELETE_RELEASE_ENTITY,
    TRY_NEW_RELEASE,
    TRY_UPDATE_RELEASE_ENTITY,
    TryDeleteReleaseAction,
    TryNewReleaseAction,
    TryUpdateReleaseAction,
    TryUpdateReleaseEntityAction,
    updateReleaseEntitySuccess,
    UpdateReleaseResponse,
    updateReleaseSuccess,
} from '../actions/release';
import { loadingActionStart, loadingStopAction } from '../actions/loading';
import {
    AllAppSettingsUpdatableTypes,
    AllAppSettingsV2UpdatableTypes,
    AllAuthUpdatableTypes,
    AllBuildDistroUpdatableTypes,
    AllChecklistItemUpdatableTypes,
    AllDevicesUpdatableTypes,
    AllFeatureFlagUpdatableTypes,
    AllIntegrationDeletableTypes,
    AllIntegrationRefreshableTypes,
    AllIntegrationUpdatableTypes,
    AllOrgSettingsUpdatableTypes,
    AllPublicApiUpdatableTypes,
    AllReleaseStepUpdatableTypes,
    AllReleaseUpdatableTypes,
    BuildDistributionUpdatable,
    OrgSettingsUpdatable,
    ReleaseStepUpdatable,
    Updatable,
    UserUpdatable,
} from '../actions/updatable';
import { updatedStartAction, updatedStopAction, willUpdateStartAction, willUpdateStopAction } from '../actions/updated';
import {
    TRY_REFRESH_INTEGRATIONS,
    TryRefreshIntegrationsAction,
    TryUpdateAppSettingsAction,
    TryUpdateAppSettingsV2Action,
    updateAppSettingsSuccessAction,
} from '../actions/appSettings';
import {
    CREATE_INTEGRATION_REQUEST_SUCCESS,
    CreateDeleteIntegrationResponse,
    createIntegrationSuccess,
    DeleteIntegrationAction,
    deleteIntegrationSuccess,
    refreshIntegrationSuccess,
    TryCreateIntegrationAction,
    TryRefreshIntegrationAction,
    TryUpdateIntegrationAction,
    updateIntegrationsSuccess,
    updateIntegrationSuccess,
} from '../actions/integrations';
import { clearFailure, requestFailedAction } from '../actions/failed';
import { newNotification } from '../actions/notifications';
import { orgStateUpdated } from '../actions/organization';
import { newPasswordSuccess, TryNewPasswordAction, TrySignUpAction } from '../actions/user';
import { dashboardStateUpdatedFromWebsocket } from '../actions/dashboardState';
import * as GoogleAnalytics from '../utils/ga';
import userflow from 'userflow.js';
import * as HubspotUtils from '../utils/hubspot';
import {
    appSettingsApiRequestForAppUpdateType,
    appSettingsV2ApiRequestForAppUpdateType,
    fetchEntityRequestForEntityType,
    fetchEntityRequestForEntityTypeV2,
    fetchEntityUpdateAction,
    fetchPaginatedEntitiesRequestForEntityType,
    fetchPaginatedEntitiesUpdateAction,
    fetchPaginatedEntitiesUpdatePaginationDataAction,
    orgSettingsApiRequestForOrgUpdateType,
    runwayModelsFromFetchEntityResponse,
    updatableRequestForUpdatable,
    updateApiForChecklistItemUpdatable,
    updateBuildDistributionBucketRequestForAction,
    updateDevicesRequestForAction,
    updateFeatureFlagsRequestForFeatureFlagUpdatable,
    updateReleaseApiRequestForReleaseUpdatable,
    updateReleaseStepApiRequestForReleaseStepUpdatableType,
} from '../helpers/apiHelpers';
import {
    authSuccess,
    clearAuth,
    redirectAuthNeeded,
    TRY_REFRESH_AUTH_TOKEN,
    TRY_SILENT_REFRESH_TOKEN,
    TryRefreshAuthTokenAction,
    updateTwoFactorAuthRequired,
} from '../actions/auth';
import {
    selectAllAppGroupNamesInOrg,
    selectAllAppsIdsInOrg,
    selectApp,
    selectAppCount,
    selectAuthCredentials,
    selectBuildDistributionBucketById,
    selectCanEnableMergeAccountsSetting,
    selectIsAppsDemoModeEnabled,
    selectIsAppStateFetchedForApps,
    selectIsDemoInstance,
    selectIsDemoModeEnabledForRelease,
    selectMergeAccountsEnabled,
    selectOrg,
    selectRelease,
    selectReleaseCount,
    selectUser,
    selectUserflowIdentitySignature,
    selectUserIsAdmin,
} from '../selectors/selectors';
import {
    BucketMemberEntityRequest,
    CommonSagaActionsData,
    TryFetchEntityAction,
    TryFetchEntityActionV2,
    TryFetchPaginatedEntitiesAction,
    UpdateBuildDistroBucketAutomationSettingsRequest,
    UpdateBuildDistroBucketNotificationSettingsRequest,
} from '../actions/entities';
import {
    AppSettingsV2APIResponse,
    AuthResponse,
    ChecklistItemUpdatableAPIResponse,
    ConfigResponse,
    CreateAppAddIntegrationResponse,
    CreateAppApiResponse,
} from '../apiResponseTypes';
import {
    appGroupsDeleted,
    appGroupsUpdated,
    ConnectedAppGroupEntityResponse,
    DeletedAppGroupPayload,
} from '../actions/appGroups';
import { flatten, flattenDeep, isEqual } from 'lodash';
import { FetchableEntityType, FetchableEntityTypeV2, FetchablePaginatedEntityType } from '../entityType';
import * as WsEffects from './wsSagas';
import * as Storage from '../helpers/localStorageHelper';
import {
    clearState,
    fetchStateSuccess,
    TRY_CHANGE_ORG_FETCH_STATE,
    TRY_FETCH_STATE,
    TryChangeOrgFetchStateAction,
    TryFetchStateAction,
} from '../actions/state';
import {
    TryUpdateOrgSettingsAction,
    UPDATE_ORG_SETTINGS_SUCCESS,
    updateOrgSettingsSuccessAction,
} from '../actions/orgSettings';
import { tryWebsocketConnect, tryWebsocketDisconnect } from '../actions/ws';
import {
    getAppConfigSuccess,
    TRY_GET_APP_CONFIG,
    TRY_SILENT_GET_APP_CONFIG,
    TryUpdateAppConfigAction,
} from '../actions/appConfig';

import {
    TRACK_APP_ROUTE_EVENT,
    TRACK_BUILD_DISTRO_EVENT,
    TRACK_ONBOARDING_EVENT,
    TRACK_ORG_ROUTE_EVENT,
    TRACK_QUICK_START_EVENT,
    TRACK_RELEASE_ROUTE_EVENT,
    TRACK_RELEASE_STEP_VIEW_EVENT,
    TRACK_USER_EVENT,
    TrackAppRouteEventAction,
    TrackBuildDistroViewEventAction as TrackBuildDistroEventAction,
    TrackOnboardingEventAction,
    TrackOrgRouteEventAction,
    TrackQuickStartEventAction,
    TrackReleaseRouteEventAction,
    TrackReleaseStepViewEventAction,
    TrackUserEventAction,
} from '../actions/trackEvent';
import { allBuildDistroPropertiesFrom, allReleasePropertiesFrom } from '../helpers/trackingHelpers';
import {
    CreateApiKeyData,
    createPublicApiKey,
    CreatePublicApiKeyResponse,
    TryAddPublicApiKeyAction,
} from '../actions/publicApi';
import { RolloutMonitoringResponse, updateRolloutMonitoringForReleases } from '../actions/rolloutMonitoring';
import { GA_MEASUREMENT_ID, STAPE_ID_COOKIE_KEY } from '../constants';
import { appsAddedShouldRedirect, setQuickStartCIStepData, updatePaginationDataAction } from '../actions/ui';
import { QuickStartCISetupStepType } from '../typescriptHelpers';
import { TryNewBuildDistributionBucketAction } from '../actions/buildDistribution';
import { globalMessage } from '../utils/globalMessage';
import { TryUpdateDevicesAction, updateDevicesSuccess } from '../actions/devices';

import * as InternalFeatureFlags from '../utils/internalFeatureFlags';
import { UPDATE_FEATURE_ITEMS_SORT, UpdateFeatureItemsSortAction } from '@/actions/sorts';
import {
    REMOVE_FEATURE_ITEMS_FILTER,
    RemoveFeatureItemsFilterAction,
    UPDATE_FEATURE_ITEMS_FILTERS,
    UPDATE_GROUP_WORK_ITEMS_BY_TICKET,
    UPDATE_SHOW_FIXES_ONLY,
    UpdateFeatureItemsFiltersAction,
    UpdateGroupWorkItemsByTicketAction,
    UpdateShowFixesOnlyAction,
} from '@/actions/filters';
import { AnyFilter } from '@/types/filters';
import { SortType } from '@/types/sorts';
import { selectAppliedFilters } from '@/selectors/memoizedSelectors';
import {
    deleteChecklistItemTemplates,
    TryUpdateChecklistItemAction,
    updateChecklistItemTemplates,
} from '@/actions/checklistItems';
import { TryUpdateReleaseStepAction, updateReleaseSteps } from '@/actions/releaseStep';
import { call } from 'typed-redux-saga';
import { updateStepRuns } from '@/actions/stepRun';
import { AllRunwayUpdatables, hasSupportForParallelism, TryUpdatableAction } from '@/actions/common';
import { updateStepConfigs } from '@/actions/stepConfig';
import { StepRun } from '@/types/stepRun';
import { updateAutomations } from '@/actions/automations';
import { updateWorkflowRunStepRunGraphs } from '@/actions/workflowRunStepRunGraph';
import { updateWorkflowOverview, updateWorkflowStepGraphs } from '@/actions/workflow';
import dayjs from 'dayjs';
import { getAppUsesWorkflows } from '@/helpers';
import { updateOrgChecklistItemTemplates } from '@/actions/orgChecklistItemTemplates';
import { invalidateAppHomeCache } from '@/middlewares/defaultApi';

function* trackOrgRouteEventSaga(action: TrackOrgRouteEventAction) {
    const org = yield select(selectOrg, action.payload.orgId);
    const appIdsInOrg = yield select(selectAllAppsIdsInOrg, action.payload.orgId);
    const appGroupNamesInOrg = yield select(selectAllAppGroupNamesInOrg, action.payload.orgId);

    const baseProperties = allReleasePropertiesFrom(
        org,
        null,
        null,
        appIdsInOrg,
        appGroupNamesInOrg,
        undefined,
        undefined,
    );

    const allProperties =
        action.payload.viewType ?
            {
                ...baseProperties,
                viewType: action.payload.viewType,
            }
        :   baseProperties;

    yield* call(Analytics.track, action.payload.eventName, allProperties);
}

function* trackAppRouteEventSaga(action: TrackAppRouteEventAction) {
    const org = yield select(selectOrg, action.payload.orgId);
    const app = yield select(selectApp, action.payload.appId);

    const appIdsInOrg = yield select(selectAllAppsIdsInOrg, action.payload.orgId);
    const appGroupNamesInOrg = yield select(selectAllAppGroupNamesInOrg, action.payload.orgId);

    const baseProperties = allReleasePropertiesFrom(
        org,
        app,
        null,
        appIdsInOrg,
        appGroupNamesInOrg,
        undefined,
        undefined,
    );

    const allProperties =
        action.payload.viewType ?
            {
                ...baseProperties,
                viewType: action.payload.viewType,
            }
        :   baseProperties;

    yield* call(Analytics.track, action.payload.eventName, allProperties);
}

function* trackReleaseRouteEventSaga(action: TrackReleaseRouteEventAction) {
    const org = yield select(selectOrg, action.payload.orgId);
    const app = yield select(selectApp, action.payload.appId);
    const release = yield select(selectRelease, action.payload.releaseId);
    const appIdsInOrg = yield select(selectAllAppsIdsInOrg, action.payload.orgId);
    const appGroupNamesInOrg = yield select(selectAllAppGroupNamesInOrg, action.payload.orgId);

    const allProperties = allReleasePropertiesFrom(
        org,
        app,
        release,
        appIdsInOrg,
        appGroupNamesInOrg,
        action.payload.context,
    );

    yield* call(Analytics.track, action.payload.eventName, allProperties);
}

function* trackViewReleaseStepEventSaga(action: TrackReleaseStepViewEventAction) {
    const org = yield select(selectOrg, action.payload.orgId);
    const app = yield select(selectApp, action.payload.appId);
    const release = yield select(selectRelease, action.payload.releaseId);
    const appIdsInOrg = yield select(selectAllAppsIdsInOrg, action.payload.orgId);
    const appGroupNamesInOrg = yield select(selectAllAppGroupNamesInOrg, action.payload.orgId);

    const allProperties = allReleasePropertiesFrom(org, app, release, appIdsInOrg, appGroupNamesInOrg);

    let eventName: Analytics.Event;

    switch (action.payload.releaseStepType) {
        case ReleaseStepType.Kickoff:
            eventName = Analytics.Event.ViewKickoff;
            break;
        case ReleaseStepType.FeatureReadiness: {
            eventName = Analytics.Event.ViewFeatureReadiness;
            break;
        }
        case ReleaseStepType.ReleaseCandidate:
            eventName = Analytics.Event.ViewReleaseCandidate;
            break;
        case ReleaseStepType.RegressionTesting:
            eventName = Analytics.Event.ViewRegressionTesting;
            break;
        case ReleaseStepType.BetaTesting:
            eventName = Analytics.Event.ViewBetaTesting;
            break;
        case ReleaseStepType.Metadata:
            eventName = Analytics.Event.ViewMetadata;
            break;
        case ReleaseStepType.Screenshots:
            eventName = Analytics.Event.ViewScreenshots;
            break;
        case ReleaseStepType.Approvals:
            eventName = Analytics.Event.ViewApprovals;
            break;
        case ReleaseStepType.Submission:
            eventName = Analytics.Event.ViewSubmission;
            break;
        case ReleaseStepType.StoreReview:
            eventName = Analytics.Event.ViewAppReview;
            break;
        case ReleaseStepType.Takeoff:
            eventName = Analytics.Event.ViewTakeoff;
            break;
        case ReleaseStepType.VCSDistribution:
            eventName = Analytics.Event.ViewTakeoff;
            break;
        case ReleaseStepType.CIDistribution:
            eventName = Analytics.Event.ViewTakeoff;
            break;
        default:
            eventName = null;
    }

    if (eventName) {
        yield* call(Analytics.track, eventName, allProperties);
    }
}

function* trackBuildDistroEventSaga(action: TrackBuildDistroEventAction) {
    const org = yield select(selectOrg, action.payload.orgId);
    const app = yield select(selectApp, action.payload.appId);
    const bucket = yield select(selectBuildDistributionBucketById, action.payload.bucketId);
    const appIdsInOrg = yield select(selectAllAppsIdsInOrg, action.payload.orgId);
    const appGroupNamesInOrg = yield select(selectAllAppGroupNamesInOrg, action.payload.orgId);
    const eventName = action.payload.eventName;

    const allProperties = allBuildDistroPropertiesFrom(
        org,
        app,
        bucket,
        appIdsInOrg,
        appGroupNamesInOrg,
        null,
        action.payload.extraProperties,
    );
    if (eventName) {
        yield* call(Analytics.track, eventName, allProperties);
    }
}

function* trackUserEventSaga(action: TrackUserEventAction) {
    const org = yield select(selectOrg, action.payload.orgId);
    const app = yield select(selectApp, action.payload.appId);
    const user = yield select(selectUser);
    const eventName = action.payload.eventName;
    const appIdsInOrg = yield select(selectAllAppsIdsInOrg, action.payload.orgId);
    const appGroupNamesInOrg = yield select(selectAllAppGroupNamesInOrg, action.payload.orgId);
    const userProps = Analytics.userProperties(user);

    const allProperties = allReleasePropertiesFrom(org, app, null, appIdsInOrg, appGroupNamesInOrg);
    if (eventName) {
        yield* call(Analytics.track, eventName, { ...allProperties, ...userProps });
    }
}

function* trackOnboardingEventSaga(action: TrackOnboardingEventAction) {
    const org = yield select(selectOrg, action.payload.orgId);
    const app = yield select(selectApp, action.payload.appId);
    const user = yield select(selectUser);
    const eventName = action.payload.eventName;
    const taskType = action.payload.taskType;
    const appIdsInOrg = yield select(selectAllAppsIdsInOrg, action.payload.orgId);
    const appGroupNamesInOrg = yield select(selectAllAppGroupNamesInOrg, action.payload.orgId);
    const userProps = Analytics.userProperties(user);
    const taskProps = {
        taskType,
    };

    const allProperties = allReleasePropertiesFrom(org, app, null, appIdsInOrg, appGroupNamesInOrg);
    if (eventName) {
        yield* call(Analytics.track, eventName, { ...allProperties, ...userProps, ...taskProps });
    }
}

function* trackQuickStartEventSaga(action: TrackQuickStartEventAction) {
    const org = yield select(selectOrg, action.payload.orgId);
    const app = yield select(selectApp, action.payload.appId);

    const appProperties = app ? Analytics.appProperties(app) : {};
    const appsInOrg = yield select(selectAllAppsIdsInOrg, org.orgId);
    const appGroupsInOrg = yield select(selectAllAppGroupNamesInOrg, org.orgId);
    const usesWorkflows = !!app && getAppUsesWorkflows(app);
    const orgProperties =
        org && appGroupsInOrg && appsInOrg ?
            Analytics.orgProperties(org, appsInOrg, appGroupsInOrg, usesWorkflows)
        :   {};

    const eventName = action.payload.eventName;

    if (eventName) {
        yield* call(Analytics.track, eventName, {
            ...orgProperties,
            ...appProperties,
            ...action.payload.extraData,
        });
    }
}

function* trackAddAppEvent(orgId: string, responseArray: CreateAppApiResponse[]) {
    const appsProperties: AppProperties[] = [];
    const appsUseWorkflows: boolean[] = [];
    for (const response of responseArray) {
        for (const appData of response.apps) {
            const app = yield select(selectApp, appData.appId);
            const usesWorkflows = !!app && getAppUsesWorkflows(app);
            appsUseWorkflows.push(usesWorkflows);
            const properties = Analytics.appProperties(app);
            appsProperties.push(properties);
        }
    }

    const user = yield select(selectUser);
    const userProperties = Analytics.userProperties(user);

    const org = yield select(selectOrg, orgId);
    const appsInOrg = yield select(selectAllAppsIdsInOrg, org.orgId);
    const appGroupsInOrg = yield select(selectAllAppGroupNamesInOrg, org.orgId);
    const usesWorkflows = appsUseWorkflows.some((value) => value === true);
    const orgProperties =
        org && appGroupsInOrg && appsInOrg ?
            Analytics.orgProperties(org, appsInOrg, appGroupsInOrg, usesWorkflows)
        :   {};

    yield* call(Analytics.track, Analytics.Event.AddApp, { appsProperties, userProperties, orgProperties }, [
        Analytics.TrackingService.LogRocket,
    ]);
}

function* trackSignUpWithEmailPasswordEvent(userId: string) {
    yield* call(Analytics.track, Analytics.Event.SignUp, { userId: userId, email: userId }, [
        Analytics.TrackingService.LogRocket,
    ]);

    yield* call(Analytics.trackSignupConversionPixels, GoogleAnalytics.SignUpLoginMethod.EmailPassword, {
        userId,
        orgId: '', // note, sign ups with email & pass don't have an orgId until they've verified their email
    });
}

function logrocketIdentify(response: DashboardState) {
    // LogRocket

    // don't record on dev mode
    if (!response.user || process.env.NODE_ENV == 'development') {
        return;
    }

    const user = response.user;

    let orgId = null;
    if (response.organizations.length !== 0) {
        orgId = response.organizations[0].id;
    }

    const groupsString = response.user.groups.join(', ');
    const permissionsString = response.user.permissions.join(', ');

    const userProperties = {
        roles: groupsString,
        permissions: permissionsString,
        email: response.user.email,
    };

    if (orgId) {
        userProperties[orgId] = orgId;
    }

    Analytics.identify(user.uuid, userProperties, Analytics.TrackingService.LogRocket, orgId);
}

function amplitudeIdentifyAndStartExperimentsClient(response: DashboardState) {
    if (!response.user) {
        return;
    }

    const orgId = response.organizations[0].id;
    const userProperties = Analytics.userProperties(response.user);
    Analytics.identify(response.user.uuid, userProperties, Analytics.TrackingService.Amplitude);

    const experimentUser: InternalFeatureFlags.ExperimentUser = {
        user_properties: {
            orgId: orgId,
        },
        groups: {
            org: [orgId],
        },
    };

    InternalFeatureFlags.startAmplitudeExperimentClient(experimentUser);
}

function* getUserflowUserAttributes(user: User) {
    const org: OrganizationEntity = yield select(selectOrg);
    const mergedAccountsEnabled = yield select(selectMergeAccountsEnabled, org.id);
    const appCount = yield select(selectAppCount);
    const releasesCount = yield select(selectReleaseCount);
    const isAdmin = yield select(selectUserIsAdmin);
    const canEnableMergeAccountsSetting = yield select(selectCanEnableMergeAccountsSetting, org.id);

    const orgSubscriptionPlan = org.subscriptionInfo?.subscriptionStatus;
    const orgTrialDaysRemaining = org.subscriptionInfo?.trialDaysRemaining;
    const deviceType = window.innerWidth > 800 ? 'desktop' : 'mobile';

    return {
        email: user.email,
        name: user.firstName,
        roles: user.groups,
        signed_up_at: user.createdAt,
        num_of_apps: appCount,
        num_of_releases: releasesCount,
        is_admin: isAdmin,
        merge_accounts_to_org_enabled: mergedAccountsEnabled,
        org_id: org.orgId,
        can_enable_merge_accounts_setting: canEnableMergeAccountsSetting,
        org_users_count: org.users.length,
        needs_password_reset: user.needsNewPassword,
        org_subscription_plan: orgSubscriptionPlan,
        org_trial_days_remaining: orgTrialDaysRemaining,
        device_type: deviceType,
        stape_id: getCookie(STAPE_ID_COOKIE_KEY),
    };
}

function* userFlowIdentify() {
    const user = yield select(selectUser);
    const signature = yield select(selectUserflowIdentitySignature);

    if (signature && user) {
        try {
            const attributes = yield* call(getUserflowUserAttributes, user);

            userflow.identify(user.uuid, attributes, { signature });
        } catch (e) {
            Sentry.captureMessage(`Failed to identify userflow user with error: ${e}`);
        }
    } else {
        const deviceType = window.innerWidth > 800 ? 'desktop' : 'mobile';

        userflow.identifyAnonymous({
            deviceType,
            stapeId: getCookie(STAPE_ID_COOKIE_KEY),
        });
    }
}

// eslint-disable-next-line require-yield
function* userflowLogout() {
    try {
        userflow.reset();
    } catch {
        // No-op
    }
}

function* updateUserflowUser() {
    const user = yield select(selectUser);
    const signature = yield select(selectUserflowIdentitySignature);

    if (user && signature) {
        try {
            const attributes = yield* call(getUserflowUserAttributes, user);

            userflow.updateUser(attributes);
        } catch (e) {
            Sentry.captureMessage(`Failed to update userflow user attributes with error: ${e}`);
        }
    }
}

function getCookie(name: string): string | null {
    const nameEQ = `${name}=`;
    const cookie = document?.cookie
        .split(';')
        .map((c) => c.trim())
        .find((c) => c.startsWith(nameEQ));

    return cookie?.substring(nameEQ.length);
}

function hubspotIdentify(user: User) {
    const userProperties = HubspotUtils.userProperties(user);

    HubspotUtils.identify(userProperties);
}

function setLastLogin() {
    const now = Date.now();

    Storage.setItem(Storage.LAST_LOGIN, now);
}

function* getAppConfigSaga(action: TryUpdateAppConfigAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const response: ConfigResponse = yield* call(API.getAppConfig);

        yield put(getAppConfigSuccess(response));

        yield spawn(updated, action.type);
    } catch (e) {
        yield spawn(failure, action.type, e.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* switchOrgFetchState(action: TryChangeOrgFetchStateAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);
        const response: DashboardState = yield* call(API.fetchState, action.payload, auth);
        const orgs = response.organizations;

        yield spawn(willUpdate, action.type);

        // give the components a second to update
        yield delay(200);

        // clear any existing state
        yield put(clearState());

        // store the new state
        yield put(fetchStateSuccess(response));

        if (orgs.length > 0) {
            yield put(tryWebsocketDisconnect()); // first disconnect existing connection, it will reconnect on its own with the correct orgId

            const orgId = orgs[0].id;

            Storage.setDefaultOrgIdForUserId(action.payload.userId, orgId);
        }

        // update userflow properties
        yield spawn(updateUserflowUser);

        // TODO: update other third party tracking properties
        // not needed right now since only runway admins can change orgs

        yield spawn(updated, action.type);
    } catch (e) {
        yield spawn(failure, action.type, e.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* fetchStateSaga(action: TryFetchStateAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);

        const response: DashboardState = yield* call(API.fetchState, action.payload, auth);
        const orgs = response.organizations;

        yield spawn(willUpdate, action.type);

        yield put(fetchStateSuccess(response));

        let orgId = '';

        if (orgs.length > 0) {
            if (DISABLE_WEBSOCKET_CONNECTION !== true) {
                yield put(tryWebsocketConnect());
            }

            orgId = orgs[0].id;
        }

        yield spawn(logrocketIdentify, response);
        yield spawn(amplitudeIdentifyAndStartExperimentsClient, response);

        yield spawn(userFlowIdentify);
        yield spawn(hubspotIdentify, response.user);

        yield spawn(GoogleAnalytics.config, GA_MEASUREMENT_ID, {
            user_id: response.user.id,
            permissions: response.user.permissions,
            org_id: orgId,
        });

        yield spawn(GoogleAnalytics.track, GoogleAnalytics.EventName.Login, { method: 'auth' });

        yield spawn(updated, action.type);
    } catch (e) {
        yield spawn(failure, action.type, e.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* fetchPaginatedEntitiesSaga(action: TryFetchPaginatedEntitiesAction) {
    yield put(clearFailure(action.type, action.payload.id));
    yield put(loadingActionStart(action.type, action.payload.id));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);
        const request = fetchPaginatedEntitiesRequestForEntityType(action);

        const response = yield* call(request, action.payload.data, action.payload.limit, action.payload.offset, auth);
        const updatedAction = fetchPaginatedEntitiesUpdateAction(action, response);
        const updatePaginationDataAction = fetchPaginatedEntitiesUpdatePaginationDataAction(action, response);

        yield put(updatedAction);
        yield put(updatePaginationDataAction);

        yield spawn(updated, action.type, action.payload.id);
    } catch (e) {
        yield spawn(failure, action.type, e.message, action.payload.id);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.id));
    }
}

function* fetchEntitySaga(action: TryFetchEntityAction) {
    yield put(clearFailure(action.type, action.payload.id));
    yield put(loadingActionStart(action.type, action.payload.id));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);
        const request = fetchEntityRequestForEntityType(action);

        const response = yield* call(request, action.payload.data, auth);
        const updatedAction = fetchEntityUpdateAction(action, response);

        yield put(updatedAction);

        yield spawn(updated, action.type, action.payload.id);
    } catch (e) {
        yield spawn(failure, action.type, e.message, action.payload.id);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.id));
    }
}

// common actions wrapper for all actions that require loading, optional paginationData and failure/warning/info handling. Can and most likely should be re-used for all actions that require these features
function* commonActionsWrapper<T extends CommonSagaActionsData>(
    action: T,
    tryBlock: (action: T, auth: AuthCredentials) => Generator<unknown, RunwayResponseV2<RunwayModelsResponse>>,
) {
    yield put(clearFailure(action.type, action.payload.id));
    yield put(loadingActionStart(action.type, action.payload.id));
    try {
        const auth = yield* call(getAuthCredentialsForSaga);
        const response = yield* tryBlock(action, auth);

        // if paginationData is provided, update it
        if (action.paginationData) {
            yield put(updatePaginationDataAction(action));
        }

        switch (response.type) {
            case RunwayResponseType.Info:
            case RunwayResponseType.Warning:
            case RunwayResponseType.Success:
                yield spawn(updated, action.type, action.payload.id, response.type);
                break;
            default:
                throw new Error(`Unexpected response type: ${response.type}`);
        }
    } catch (e) {
        if (e instanceof RunwayResponseError) {
            // TODO: at some point we might want to use the data from the RunwayResponseError to display a more detailed error message like validation data per field for example. That should be handled here by using `e.runwayResponse.data`.
            //  For now we just display the error message.
            yield spawn(failure, action.type, e.message, action.payload.id);
        } else {
            yield spawn(failure, action.type, e.message, action.payload.id);
        }
    } finally {
        yield put(loadingStopAction(action.type, action.payload.id));
    }
}

function* fetchEntityV2Saga(action: TryFetchEntityActionV2) {
    yield* commonActionsWrapper<TryFetchEntityActionV2>(action, function* (action, auth) {
        const request = fetchEntityRequestForEntityTypeV2(action);

        const response = yield* call(request, action.payload.data, auth);

        const models = runwayModelsFromFetchEntityResponse(action, response);

        yield* call(updateRunwayModelsSaga, models);

        return response;
    });
}

function* runwayUpdatableSaga(updatable: TryUpdatableAction) {
    yield* commonActionsWrapper<TryUpdatableAction>(updatable, function* (updatable, auth) {
        const request = updatableRequestForUpdatable(updatable.type);
        const response = yield* call(request, updatable.payload.resourceIds, updatable.payload.requestData, auth);

        yield* call(updateRunwayModelsSaga, response.data);
        return response;
    });
}

function* logoutSaga(action: TryLogoutAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);

        yield* call(API.logout, auth);

        yield put(clearAuth());
        yield put(logoutSuccess());

        yield* call(userflowLogout);

        yield spawn(updated, action.type);
    } catch (e) {
        yield spawn(failure, action.type, e.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* loginSaga(action: TryLoginAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const response: AuthResponse = yield* call(API.login, action.payload);

        if (response.is2FARequired) {
            yield put(updateTwoFactorAuthRequired(response.userId));
        } else if (response.redirectUrl) {
            // redirect instead of saving auth
            yield put(redirectAuthNeeded({ authRedirectUrl: response.redirectUrl }));
        } else {
            yield put(authSuccess(response));
            yield* call(setLastLogin);
            yield* call(Storage.checkAndRedirectToSavedRoute);
        }

        yield spawn(updated, action.type);
    } catch (error) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* signUpSaga(action: TrySignUpAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const response: AuthResponse = yield* call(API.signUp, action.payload);

        if (response.is2FARequired) {
            yield put(updateTwoFactorAuthRequired(response.userId));
        } else {
            yield put(authSuccess(response));
            yield* call(setLastLogin);
            yield* call(Storage.checkAndRedirectToSavedRoute);
        }

        yield spawn(updated, action.type);

        yield* call(trackSignUpWithEmailPasswordEvent, response.userId);
    } catch (error) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* verifyAuthCodeSaga(action: TryVerifyAuthCodeAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const response: AuthResponse = yield* call(API.verify2FACode, action.payload);

        if (response.redirectUrl) {
            // redirect instead of saving auth
            yield put(redirectAuthNeeded({ authRedirectUrl: response.redirectUrl }));
        } else {
            yield put(authSuccess(response));
            yield* call(setLastLogin);
            yield* call(Storage.checkAndRedirectToSavedRoute);
        }

        yield spawn(updated, action.type);
    } catch (error) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* refreshToken(action: TryRefreshAuthTokenAction) {
    yield put(loadingActionStart(action.type));

    try {
        const response: AuthResponse = yield* call(API.refreshToken, action.payload);

        yield put(authSuccess(response));
        yield* call(Storage.checkAndRedirectToSavedRoute);

        yield* call(setLastLogin);

        yield spawn(updated, action.type);
    } catch (error) {
        yield spawn(failure, action.type, error.message);

        if (error.name === API.RunwayErrorType.Unauthorized) {
            // Save the current route to local storage before redirecting
            const currentRoute = `${window.location.pathname}${window.location.search}`;
            yield* call(Storage.setAuthRedirectRoute, currentRoute);

            // refresh token failed, log out
            yield put(clearAuth());
            yield put(logoutSuccess());
        }
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* newPasswordSaga(action: TryNewPasswordAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);

        const user = yield* call(API.newPassword, action.payload, auth);

        yield put(newPasswordSuccess(user));
        yield spawn(updated, action.type);
    } catch (error) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* updateUserDevicesSaga(action: UpdateUserDevicesAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);

        const user = yield* call(API.addUserDevice, action.payload, auth);

        yield put(updateUserDevicesSuccess(user));
        yield spawn(updated, action.type);
    } catch (error) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* updateUserEmailNotificationsSaga(action: UpdateUserEmailNotificationSettingsAction) {
    yield put(clearFailure(action.type, action.payload.userId));
    yield put(loadingActionStart(action.type, action.payload.userId));
    try {
        const auth = yield* call(getAuthCredentialsForSaga);
        const user = yield* call(API.saveUserEmailNotificationSettings, action.payload, auth);
        yield put(updateUserEmailNotificationSettingsSuccess(user));
        yield spawn(updated, action.type, action.payload.userId);
    } catch (error) {
        yield spawn(failure, action.type, error.message, action.payload.userId);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.userId));
    }
}

function* updateShouldShowSimplifiedBdUISaga(action: UpdateShouldShowSimplifiedBDUIAction) {
    yield put(clearFailure(action.type, action.payload.userId));
    yield put(loadingActionStart(action.type, action.payload.userId));
    try {
        const auth = yield* call(getAuthCredentialsForSaga);
        const user = yield* call(API.updateShouldShowSimplifiedBdUI, action.payload, auth);

        yield put(updateShouldShowSimplifiedBdUISuccess(user));
        yield spawn(updated, action.type);
    } catch (error) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.userId));
    }
}

function* verifyCommsUserSaga(action: VerifyCommsUserAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));
    try {
        const auth = yield* call(getAuthCredentialsForSaga);
        yield* call(API.verifyCommsUser, action.payload, auth);

        yield put(verifyCommsUserSuccess());
        yield spawn(updated, action.type);
    } catch (error) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* willUpdate(name: Updatable | string, id?: number | string, waitPeriod = 500) {
    yield put(willUpdateStartAction(name, id));
    yield delay(waitPeriod);
    yield put(willUpdateStopAction(name, id));
}

function* updated(
    name: Updatable | string,
    id?: number | string,
    responseType: NonErrorRunwayResponseTypes = null,
    waitPeriod = 500,
) {
    yield put(updatedStartAction(name, id, responseType));
    yield delay(waitPeriod);
    yield put(updatedStopAction(name, id, responseType));
}

function* failure(name: Updatable | string, message: string, id?: number | string, waitPeriod = 500) {
    yield put(requestFailedAction(name, message, id));
    yield delay(waitPeriod);
    yield put(clearFailure(name, id));
}

function* verifyCanUpdateRelease(releaseId: string) {
    const isReleaseDemoModeEnabled = yield select(selectIsDemoModeEnabledForRelease, releaseId);
    const isDemoInstance = yield select(selectIsDemoInstance);

    if (isReleaseDemoModeEnabled || isDemoInstance) {
        throw Error('You are viewing this release in demo mode. All actions are readonly.');
    }
}

function* verifyCanUpdateApp() {
    const isDemoModeEnabled = yield select(selectIsAppsDemoModeEnabled);
    const isDemoInstance = yield select(selectIsDemoInstance);

    if (isDemoModeEnabled || isDemoInstance) {
        throw Error('You are in demo mode. All actions are readonly.');
    }
}

function* updateReleaseSaga(action: TryUpdateReleaseAction) {
    try {
        yield* call(verifyCanUpdateRelease, action.payload.requestData.releaseId);
        yield put(clearFailure(action.type, action.payload.id));
        yield put(loadingActionStart(action.type, action.payload.id));

        const request = yield* call(updateReleaseApiRequestForReleaseUpdatable, action);

        const auth = yield* call(getAuthCredentialsForSaga);

        const release: Release = yield* call(request, action.payload.requestData, auth);

        const updatedReleaseResponse: UpdateReleaseResponse = {
            releaseId: release.id,
            release,
        };

        yield put(updateReleaseSuccess(updatedReleaseResponse));

        yield spawn(updated, action.type, action.payload.id);
    } catch (error) {
        yield spawn(failure, action.type, error.message, action.payload.id);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.id));
    }
}

function* updateFeatureFlagsSaga(action: TryUpdateFeatureFlagsAction) {
    try {
        yield* call(verifyCanUpdateRelease, action.payload.requestData.releaseId);
        yield put(clearFailure(action.type, action.payload.id));
        yield put(loadingActionStart(action.type, action.payload.id));

        const request = yield* call(updateFeatureFlagsRequestForFeatureFlagUpdatable, action);

        const auth = yield* call(getAuthCredentialsForSaga);

        const featureFlag = yield* call(request, action.payload.requestData, auth);

        yield put(
            updateFeatureFlagsSuccess({
                releaseId: action.payload.requestData.releaseId,
                featureFlags: [featureFlag],
            }),
        );

        yield spawn(updated, action.type, action.payload.id);
    } catch (error) {
        yield spawn(failure, action.type, error.message, action.payload.id);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.id));
    }
}

function* updateReleaseStepSaga(action: TryUpdateReleaseStepAction<ReleaseStepUpdatable>) {
    try {
        yield* call(verifyCanUpdateRelease, action.payload.resourceIds.releaseId);
        yield put(clearFailure(action.type, action.payload.id));
        yield put(loadingActionStart(action.type, action.payload.id));

        const request = yield* call(updateReleaseStepApiRequestForReleaseStepUpdatableType, action.type);

        const auth = yield* call(getAuthCredentialsForSaga);

        const models = yield* call(request, action.payload.resourceIds, action.payload.requestData, auth);

        yield* call(updateRunwayModelsSaga, models);

        yield spawn(updated, action.type, action.payload.id);
    } catch (error) {
        yield spawn(failure, action.type, error.message, action.payload.id);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.id));
    }
}

function* updateRunwayModelsSaga(runwayModels?: RunwayModelsResponse) {
    if (!runwayModels) {
        return;
    }

    const {
        stepRuns,
        stepConfigs,
        releaseSteps,
        checklistItemTemplates,
        automations,
        releases,
        orgEntity,
        apps,
        workflowRunStepRunGraphs,
        workflowStepGraphs,
        deletedChecklistItemTemplateIds,
        workflowOverview,
        orgChecklistItemTemplates,
    } = runwayModels;

    if (releaseSteps) {
        yield put(updateReleaseSteps(releaseSteps));
    }

    if (stepRuns) {
        yield put(updateStepRuns(stepRuns));
    }

    if (stepConfigs) {
        yield put(updateStepConfigs(stepConfigs));
    }

    if (checklistItemTemplates) {
        yield put(updateChecklistItemTemplates(checklistItemTemplates));
    }

    if (automations) {
        yield put(updateAutomations(automations));
    }

    if (workflowRunStepRunGraphs) {
        yield put(updateWorkflowRunStepRunGraphs(workflowRunStepRunGraphs));
    }

    if (workflowStepGraphs) {
        yield put(updateWorkflowStepGraphs(workflowStepGraphs));
    }

    if (workflowOverview) {
        yield put(updateWorkflowOverview(workflowOverview));
    }

    if (releases) {
        // probably a left over from a previous implementation but I'm mapping the releases to a ConnectedReleaseResponse object which requires appId and orgId, however, these are never used. It's ok... this will not exist once workflowRuns replace releases...
        yield put(releasesUpdated(releases.map((release) => ({ appId: '', orgId: '', release }))));
    }

    if (orgEntity) {
        yield put(updateOrgSettingsSuccessAction(orgEntity));
    }

    if (apps) {
        yield put(appsUpdated(apps.map((app) => ({ orgId: '', orgIdParam: '', appGroupId: '', app: app }))));
    }

    if (orgChecklistItemTemplates) {
        yield put(updateOrgChecklistItemTemplates(orgChecklistItemTemplates));
    }

    // -------- delete entities ---------

    if (deletedChecklistItemTemplateIds) {
        yield put(deleteChecklistItemTemplates(deletedChecklistItemTemplateIds));
    }
}

function* updateChecklistItemSaga(action: TryUpdateChecklistItemAction) {
    try {
        yield* call(verifyCanUpdateRelease, action.payload.requestData.releaseId);
        yield put(clearFailure(action.type, action.payload.id));
        yield put(loadingActionStart(action.type, action.payload.id));

        const request = yield* call(updateApiForChecklistItemUpdatable, action);

        const auth = yield* call(getAuthCredentialsForSaga);

        const response: ChecklistItemUpdatableAPIResponse = yield* call(request, action.payload.requestData, auth);

        if (response.release) {
            const release = response.release;

            const updatedReleaseResponse: UpdateReleaseResponse = {
                releaseId: release.id,
                release,
            };

            yield put(updateReleaseSuccess(updatedReleaseResponse));
        } else if (response.rolloutMonitoring) {
            const rolloutMonitoringResponse: RolloutMonitoringResponse = {
                rolloutMonitoring: response.rolloutMonitoring,
                releaseId: action.payload.requestData.releaseId,
                appId: action.payload.requestData.appId,
                orgId: action.payload.requestData.orgId,
            };

            yield put(updateRolloutMonitoringForReleases([rolloutMonitoringResponse]));
        }

        yield spawn(updated, action.type, action.payload.id);
    } catch (error) {
        yield spawn(failure, action.type, error.message, action.payload.id);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.id));
    }
}

function* createReleaseSaga(action: TryNewReleaseAction) {
    yield put(clearFailure(action.type, action.payload.releaseId));
    yield put(loadingActionStart(action.type, action.payload.releaseId));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);

        const release = yield* call(API.createNewRelease, action.payload.request, auth);
        const actionPayload: ConnectedReleaseResponse = {
            appId: action.payload.appId,
            orgId: action.payload.orgId,
            orgIdParam: action.payload.orgIdParam,
            appIdParam: action.payload.appIdParam,
            release,
        };

        yield put(invalidateAppHomeCache({ orgId: actionPayload.orgId, appId: actionPayload.appId }));

        if (action.payload.isRollbackConversion) {
            yield spawn(updated, action.type, action.payload.releaseId);

            // wait for state to update with deleted release
            yield delay(200);

            yield put(newReleaseSuccessAction(actionPayload));
        } else {
            yield put(newReleaseSuccessAction(actionPayload));

            yield spawn(updated, action.type);
        }
    } catch (error) {
        yield spawn(failure, action.type, error.message, action.payload.releaseId);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.releaseId));
    }
}

function* updateReleaseEntitySaga(action: TryUpdateReleaseEntityAction) {
    try {
        yield* call(verifyCanUpdateRelease, action.payload.request.releaseId);
        yield put(clearFailure(action.type));
        yield put(loadingActionStart(action.type));

        const auth = yield* call(getAuthCredentialsForSaga);

        const release = yield* call(API.updateRelease, action.payload.request, auth);
        const actionPayload: ConnectedReleaseResponse = {
            appId: action.payload.appId,
            orgId: action.payload.orgId,
            orgIdParam: action.payload.orgIdParam,
            appIdParam: action.payload.appIdParam,
            release,
        };

        yield put(updateReleaseEntitySuccess(actionPayload));
        yield spawn(updated, action.type);

        const prevReleaseId = action.payload.request.releaseId;

        if (prevReleaseId !== release.id) {
            // release id changed, need to delete previous entity from store
            const deleteEntityPayload: DeleteReleaseEntityPayload = {
                appId: action.payload.appId,
                orgId: action.payload.orgId,
                releaseId: action.payload.request.releaseId,
                orgIdParam: action.payload.orgIdParam,
                appIdParam: action.payload.appIdParam,
            };

            // wait for state to update with updated release
            yield delay(1600);

            // delete previous release
            yield put(deleteReleaseEntity(deleteEntityPayload));
        }
    } catch (error) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* deleteReleaseSaga(action: TryDeleteReleaseAction) {
    try {
        yield* call(verifyCanUpdateRelease, action.payload.releaseId);
        yield put(clearFailure(action.type, action.payload.releaseId));
        yield put(loadingActionStart(action.type, action.payload.releaseId));

        const auth = yield* call(getAuthCredentialsForSaga);

        yield* call(willUpdate, action.type, action.payload.releaseId);

        yield* call(API.deleteRelease, action.payload, auth);

        const deleteEntityPayload: DeleteReleaseEntityPayload = {
            appId: action.payload.appId,
            orgId: action.payload.orgId,
            orgIdParam: action.payload.orgIdParam,
            appIdParam: action.payload.appIdParam,
            releaseId: action.payload.releaseId,
        };

        yield put(invalidateAppHomeCache({ orgId: deleteEntityPayload.orgId, appId: deleteEntityPayload.appId }));

        yield spawn(updated, action.type, action.payload.releaseId);

        // wait for state to update with deleted release
        yield delay(500);

        // delete previous release
        yield put(deleteReleaseEntity(deleteEntityPayload));
    } catch (error) {
        yield spawn(failure, action.type, error.message, action.payload.releaseId);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.releaseId));
    }
}

// build distro

function* createBuildDistributionBucketSaga(action: TryNewBuildDistributionBucketAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);

        const newBucket = yield* call(API.createBuildDistributionBucket, action.payload, auth);
        const actionPayload: NewBuildDistributionBucketSuccessResponse = {
            appId: action.payload.appId,
            orgId: action.payload.orgId,
            bucket: newBucket,
        };

        yield put(newBuildDistributionBucketSuccess(actionPayload));

        yield spawn(updated, action.type);
    } catch (error) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* shareBuildDistributionBuildWithTestersSaga(action: ShareBuildDistributionBuildWithTestersAction) {
    yield put(clearFailure(action.type, action.payload.buildId));
    yield put(loadingActionStart(action.type, action.payload.buildId));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);

        const build = yield* call(API.shareBuildDistributionBuildWithTesters, action.payload, auth);
        const actionPayload: ShareBuildDistributionBuildWithTestersSuccessResponse = {
            appId: action.payload.appId,
            orgId: action.payload.orgId,
            build,
        };

        yield put(shareBuildDistributionBuildWithTestersSuccess(actionPayload));

        yield spawn(updated, action.type, action.payload.buildId);
    } catch (error) {
        yield spawn(failure, action.type, error.message, action.payload.buildId);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.buildId));
    }
}

function* triggerReleaseWorkflowBuildSaga(action: TriggerReleaseWorkflowBuildAction) {
    yield put(clearFailure(action.type, action.payload.releaseId));
    yield put(loadingActionStart(action.type, action.payload.releaseId));

    try {
        yield* call(verifyCanUpdateRelease, action.payload.releaseId);

        const auth = yield* call(getAuthCredentialsForSaga);

        yield* call(API.triggerBuildWorkflow, action.payload, auth);

        yield spawn(updated, action.type, action.payload.releaseId);
    } catch (error) {
        yield spawn(failure, action.type, error.message, action.payload.releaseId);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.releaseId));
    }
}

function* triggerBuildDistributionBuildSaga(action: TriggerBuildDistributionBuildAction) {
    yield put(clearFailure(action.type, action.payload.bucketId));
    yield put(loadingActionStart(action.type, action.payload.bucketId));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);

        yield* call(API.triggerBuildDistributionBucketWorkflow, action.payload, auth);

        yield spawn(updated, action.type, action.payload.bucketId);
    } catch (error) {
        yield spawn(failure, action.type, error.message, action.payload.bucketId);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.bucketId));
    }
}

function* updateBuildDistributionBuildTesterNotesSaga(action: UpdateBuildDistributionBuildTesterNotesAction) {
    yield put(clearFailure(action.type, action.payload.buildId));
    yield put(loadingActionStart(action.type, action.payload.buildId));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);

        const updatedBuild = yield* call(API.updateBuildDistributionBuildTesterNotes, action.payload, auth);
        const actionPayload: UpdateBuildDistributionBuildTesterNotesSuccessResponse = {
            appId: action.payload.appId,
            orgId: action.payload.orgId,
            build: updatedBuild,
        };

        yield put(updateBuildDistributionBuildTesterNotesSuccess(actionPayload));

        yield spawn(updated, action.type, action.payload.buildId);
    } catch (error) {
        yield spawn(failure, action.type, error.message, action.payload.buildId);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.buildId));
    }
}

function* archiveBuildDistributionBuildSaga(action: ArchiveBuildDistributionBuildAction) {
    yield put(clearFailure(action.type, action.payload.buildId));
    yield put(loadingActionStart(action.type, action.payload.buildId));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);

        const updatedBuild = yield* call(API.archiveBuildDistributionBuild, action.payload, auth);
        const actionPayload: ArchiveBuildDistributionBuildSuccessResponse = {
            appId: action.payload.appId,
            orgId: action.payload.orgId,
            build: updatedBuild,
        };

        yield put(archiveBuildDistributionBuildSuccess(actionPayload));

        yield spawn(updated, action.type, action.payload.buildId);
    } catch (error) {
        yield spawn(failure, action.type, error.message, action.payload.buildId);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.buildId));
    }
}

function* archiveBuildDistributionBucketSaga(action: TryArchiveBuildDistributionBucketAction) {
    yield put(clearFailure(action.type, action.payload.bucketId));
    yield put(loadingActionStart(action.type, action.payload.bucketId));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);
        const archivedBucket = yield* call(API.archiveBuildDistributionBucket, action.payload, auth);
        const actionPayload: ArchiveBuildDistributionBucketSuccessResponse = {
            appId: action.payload.appId,
            orgId: action.payload.orgId,
            bucket: archivedBucket,
        };

        yield put(archiveBuildDistributionBucketSuccess(actionPayload));

        yield spawn(updated, action.type, action.payload.bucketId);
    } catch (error) {
        yield spawn(failure, action.type, error.message, action.payload.bucketId);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.bucketId));
    }
}

function* updateBuildDistributionBucketSaga(action: TryUpdateBuildDistributionBucketAction) {
    let id: string;
    switch (action.type) {
        case BuildDistributionUpdatable.RemoveBuildDistroBucketMember:
        case BuildDistributionUpdatable.UpdateBuildDistroBucketMemberPermissions:
            id = (action.payload as BucketMemberEntityRequest).memberId;
            break;
        case BuildDistributionUpdatable.UpdateBuildDistroBucketNotificationSettings:
            id = (action.payload as UpdateBuildDistroBucketNotificationSettingsRequest).notificationId;
            break;
        case BuildDistributionUpdatable.UpdateBuildDistroBucketAutomationSettings:
            id =
                action.payload.bucketId +
                (action.payload as UpdateBuildDistroBucketAutomationSettingsRequest).automationId;
            break;
        default:
            id = action.payload.bucketId;
            break;
    }

    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);

        const request = yield* call(updateBuildDistributionBucketRequestForAction, action);

        const bucket: BuildDistroBucketBase = yield* call(request, action.payload, auth);

        yield put(
            updateDistributionBucketSuccess({
                bucket,
                appId: action.payload.appId,
                orgId: action.payload.orgId,
                bucketId: action.payload.bucketId,
            }),
        );

        // Just for this case, since removing the member would remove the component in charge of displaying the success message
        if (action.type === BuildDistributionUpdatable.RemoveBuildDistroBucketMember) {
            globalMessage.success(`Successfully removed member!`);
        }

        yield spawn(updated, action.type, id);
    } catch (e) {
        yield spawn(failure, action.type, e.message, id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* updateAppSettingsSaga(action: TryUpdateAppSettingsAction) {
    yield put(clearFailure(action.type, action.payload.id));
    yield put(loadingActionStart(action.type, action.payload.id));

    try {
        yield* call(verifyCanUpdateApp);

        const request = appSettingsApiRequestForAppUpdateType(action.type);
        const auth = yield* call(getAuthCredentialsForSaga);

        const response: AppSettings = yield* call(request, action.payload.requestData, auth);
        yield put(updateAppSettingsSuccessAction({ appId: action.payload.requestData.appId, appSettings: response }));

        yield spawn(updated, action.type, action.payload.id);
    } catch (error) {
        yield spawn(failure, action.type, error.message, action.payload.id);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.id));
    }
}

function* updateOrgSettingsSaga(action: TryUpdateOrgSettingsAction) {
    yield delay(300); // give it a second
    yield put(clearFailure(action.type, action.payload.id));
    yield put(loadingActionStart(action.type, action.payload.id));

    try {
        const request = orgSettingsApiRequestForOrgUpdateType(action.type);
        const auth = yield* call(getAuthCredentialsForSaga);

        if (action.type === OrgSettingsUpdatable.DeleteCustomGroup) {
            const models = yield* call(request, action.payload.requestData, auth);
            yield* call(updateRunwayModelsSaga, models);
        } else {
            const response = (yield* call(request, action.payload.requestData, auth)) as OrganizationEntity;
            yield put(updateOrgSettingsSuccessAction(response));
        }

        yield spawn(updated, action.type, action.payload.id);
    } catch (error) {
        yield spawn(failure, action.type, error.message, action.payload.id);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.id));
    }
}

function* addPublicApiSaga(action: TryAddPublicApiKeyAction) {
    yield delay(300); // give it a second
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);

        const response: CreatePublicApiKeyResponse = yield* call(API.addPublicApiKey, action.payload, auth);

        const apiKeyData: CreateApiKeyData = {
            keyValue: response.apiKey?.keyValue,
        };

        yield put(createPublicApiKey(apiKeyData));
        yield put(orgStateUpdated(response.orgEntity));

        yield spawn(updated, action.type);
    } catch (error) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* updateAppSettingsV2Saga(action: TryUpdateAppSettingsV2Action) {
    try {
        yield* call(verifyCanUpdateApp);

        yield put(clearFailure(action.type, action.payload.id));
        yield put(loadingActionStart(action.type, action.payload.id));

        const request = appSettingsV2ApiRequestForAppUpdateType(action.type);
        const auth = yield* call(getAuthCredentialsForSaga);

        const response: AppSettingsV2APIResponse = yield* call(request, action.payload.requestData, auth);

        // avoid updating app settings twice if app entity is present

        if (response.appEntity) {
            yield put(appEntityUpdated(response.appEntity));
        } else if (response.appSettings) {
            yield put(
                updateAppSettingsSuccessAction({
                    appId: action.payload.requestData.appId,
                    appSettings: response.appSettings,
                }),
            );
        }

        if (response.releases?.length > 0) {
            const updatedReleases = response.releases.map((release) => {
                return {
                    appId: action.payload.requestData.appId,
                    orgId: action.payload.requestData.orgId,
                    release,
                };
            });

            yield put(releasesUpdated(updatedReleases));
        }

        if (response.buildDistributionBuckets?.length > 0) {
            yield put(
                updateDistributionBucketsSuccess({
                    buckets: response.buildDistributionBuckets,
                    appId: action.payload.requestData.appId,
                    orgId: action.payload.requestData.orgId,
                }),
            );
        }

        if (response.integrations?.length > 0) {
            yield put(
                updateIntegrationsSuccess({
                    appId: action.payload.requestData.appId,
                    integrations: response.integrations,
                }),
            );
        }

        if (response.organizationEntity) {
            yield put(updateOrgSettingsSuccessAction(response.organizationEntity));
        }

        if (response.rolloutMonitoringForReleases) {
            const rolloutMonitoringResponses = [];
            for (const releaseId of Object.keys(response.rolloutMonitoringForReleases)) {
                const rolloutMonitoringResponse: RolloutMonitoringResponse = {
                    rolloutMonitoring: response.rolloutMonitoringForReleases[releaseId],
                    releaseId: releaseId,
                    appId: action.payload.requestData.appId,
                    orgId: action.payload.requestData.orgId,
                };

                rolloutMonitoringResponses.push(rolloutMonitoringResponse);
            }

            if (rolloutMonitoringResponses.length > 0) {
                yield put(updateRolloutMonitoringForReleases(rolloutMonitoringResponses));
            }
        }

        yield spawn(updated, action.type, action.payload.id);
    } catch (error) {
        yield spawn(failure, action.type, error.message, action.payload.id);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.id));
    }
}

function* createIntegrationSaga(action: TryCreateIntegrationAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);
        const response: CreateDeleteIntegrationResponse | CreateAppAddIntegrationResponse = yield* call(
            action.payload.isQuickStartCI ? API.createQuickStartIntegration : API.createIntegration,
            action.payload,
            auth,
        );

        yield put(createIntegrationSuccess(response));

        if (action.payload.isQuickStartCI) {
            const addAppAndIntegrationResponse = response as CreateAppAddIntegrationResponse;
            const createAppResponse: CreateAppApiResponse = {
                appGroup: addAppAndIntegrationResponse.appGroup,
                apps: [{ ...addAppAndIntegrationResponse.appEntity, releases: [] }], // the normal create app endpoint returns releases, but when adding via integration no releases are expected
            };

            yield* call(
                processAddedApps,
                [createAppResponse],
                response.orgEntity.orgId,
                response.orgEntity.orgId,
                false,
            );
        }

        yield spawn(updated, action.type, response.integrationEntity?.installationId ?? null);

        if (action.payload.isQuickStartCI) {
            yield put(
                setQuickStartCIStepData({
                    stepType: QuickStartCISetupStepType.WhatIsQuickStartCI,
                    appId: response.appEntity.appId,
                    data: {
                        visited: true,
                    },
                }),
            );

            yield put(
                setQuickStartCIStepData({
                    stepType: QuickStartCISetupStepType.VCSIntegration,
                    appId: undefined, // this is to store it in the app-less data store
                    data: {
                        newAppId: response.appEntity.appId,
                    },
                    shouldSkipSavingToLocalStorage: true,
                }),
            );
        }
    } catch (error) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* refreshIntegrationSaga(action: TryRefreshIntegrationAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);
        const response: CreateDeleteIntegrationResponse = yield* call(API.refreshIntegration, action.payload, auth);

        yield put(refreshIntegrationSuccess(response));

        yield spawn(updated, action.type, response.integrationEntity?.installationId ?? null);
    } catch (error) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* updateIntegrationSaga(action: TryUpdateIntegrationAction) {
    const id = action.payload.integrationId;
    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);
        const response = yield* call(API.updateIntegration, action.payload, auth);

        const appSettings = response;
        const appId = action.payload.appId;

        yield put(updateIntegrationSuccess({ appId, appSettings }));
        yield spawn(updated, action.type, id);
    } catch (error) {
        yield spawn(failure, action.type, error.message, id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* deleteIntegrationSaga(action: DeleteIntegrationAction) {
    const id = action.payload.integrationId;
    yield put(clearFailure(action.type, id));
    yield put(loadingActionStart(action.type, id));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);
        const response = yield* call(API.deleteIntegration, action.payload, auth);

        yield put(deleteIntegrationSuccess(response));

        // intentionally not passing the integration id to updated, as the integration is already deleted
        yield spawn(updated, action.type);
    } catch (error) {
        yield spawn(failure, action.type, error.message, id);
    } finally {
        yield put(loadingStopAction(action.type, id));
    }
}

function* refreshIntegrations(action: TryRefreshIntegrationsAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);

        yield* call(API.refreshIntegrations, action.payload, auth);

        yield spawn(updated, action.type);
    } catch (error) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

function* updateDevicesSaga(action: TryUpdateDevicesAction) {
    yield put(clearFailure(action.type, action.payload.appId));
    yield put(loadingActionStart(action.type, action.payload.appId));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);
        const response: GetAllDevicesResponse = yield* call(
            updateDevicesRequestForAction(action),
            action.payload,
            auth,
        );

        const orgId = action.payload.orgId;
        const appId = action.payload.appId;

        yield put(updateDevicesSuccess({ appId, orgId, ...response }));
        yield spawn(updated, action.type, action.payload.appId);
    } catch (error) {
        yield spawn(failure, action.type, error.message, action.payload.appId);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.appId));
    }
}

export function* handleStateUpdateEvents(
    events: WebsocketStateUpdateEvent[],
    isAppStateFetchedForApps: Record<string, boolean>,
    packageVersion: string,
) {
    for (const modelType of AllStateUpdateEventModelTypes) {
        const allModelTypeEvents = events.filter((event) => {
            const eventMatchesModelType = event.data.modelType === modelType;
            const eventMatchesPackageVersion = event.version === packageVersion;

            return eventMatchesModelType && eventMatchesPackageVersion;
        });

        if (allModelTypeEvents.length === 0) {
            continue;
        }

        switch (modelType) {
            case ModelType.App: {
                const deletedApps: DeletedAppEntityPayload[] = [];
                const connectedApps: ConnectedAppEntityResponse[] = [];

                allModelTypeEvents.forEach((event) => {
                    if (event.data.deletedAppId) {
                        deletedApps.push({
                            orgId: event.data.orgId,
                            orgIdParam: event.data.orgIdParam,
                            appGroupId: event.data.appGroupId,
                            appId: event.data.deletedAppId,
                        });
                    } else {
                        const app = event.data.model as App;

                        const isAppStateFetched = isAppStateFetchedForApps[app.id];

                        // only persist app state if it's previously been fetched & persisted
                        if (isAppStateFetched) {
                            connectedApps.push({
                                orgId: event.data.orgId,
                                orgIdParam: event.data.orgIdParam,
                                appGroupId: event.data.appGroupId,
                                app,
                            });
                        }
                    }
                });

                if (connectedApps.length > 0) {
                    yield put(appsUpdated(connectedApps));

                    if (process.env.NODE_ENV !== Environment.Production) {
                        const message =
                            connectedApps.length > 1 ?
                                `${connectedApps.length} apps updated`
                            :   `App ${connectedApps[0].app.appId} updated`;

                        const notification = {
                            title: '📣 Websocket event',
                            message: message,
                        };

                        yield put(newNotification(notification));
                    }
                }

                if (deletedApps.length > 0) {
                    for (const deletedApp of deletedApps) {
                        yield* call(willUpdate, TRY_DELETE_APP_ENTITY, deletedApp.appId);
                    }

                    yield put(appsDeleted(deletedApps));
                }

                break;
            }
            case ModelType.Org: {
                for (const event of allModelTypeEvents) {
                    const org = event.data.model as OrganizationEntity;

                    yield put(orgStateUpdated(org));

                    if (process.env.NODE_ENV !== Environment.Production) {
                        const notification = {
                            title: '📣 Websocket event',
                            message: `Org ${org.orgId} updated`,
                        };

                        yield put(newNotification(notification));
                    }
                }

                break;
            }
            case ModelType.Release: {
                const deletedReleases: DeleteReleaseEntityPayload[] = [];
                const connectedReleases: ConnectedReleaseResponse[] = [];

                allModelTypeEvents.forEach((event) => {
                    if (event.data.prevReleaseId || event.data.deletedReleaseId) {
                        deletedReleases.push({
                            orgId: event.data.orgId,
                            appId: event.data.appId,
                            releaseId: event.data.prevReleaseId ?? event.data.deletedReleaseId,
                            appIdParam: event.data.appIdParam,
                            orgIdParam: event.data.orgIdParam,
                        });
                    }

                    if (!event.data.deletedReleaseId) {
                        const release = event.data.model as Release;
                        const payload = {
                            appId: event.data.appId,
                            orgId: event.data.orgId,
                            appIdParam: event.data.appIdParam,
                            orgIdParam: event.data.orgIdParam,
                            release,
                        };

                        connectedReleases.push(payload);
                    }
                });

                if (connectedReleases.length > 0) {
                    yield put(releasesUpdated(connectedReleases));

                    if (process.env.NODE_ENV !== Environment.Production) {
                        const message =
                            connectedReleases.length > 1 ?
                                `${connectedReleases.length} releases updated`
                            :   `Release ${connectedReleases[0].release.releaseId} updated`;

                        const notification = {
                            title: '📣 Websocket event',
                            message: message,
                        };

                        yield put(newNotification(notification));
                    }
                }

                if (deletedReleases.length > 0) {
                    for (const deletedRelease of deletedReleases) {
                        yield* call(willUpdate, TRY_DELETE_RELEASE_ENTITY, deletedRelease.releaseId);
                    }

                    yield put(deleteReleasesTriggeredFromWebsocket(deletedReleases));
                }

                break;
            }
            case ModelType.AppGroup: {
                const deletedAppGroups: DeletedAppGroupPayload[] = [];
                const connectedAppGroups: ConnectedAppGroupEntityResponse[] = [];

                allModelTypeEvents.forEach((event) => {
                    if (event.data.deletedAppGroupId) {
                        deletedAppGroups.push({
                            orgId: event.data.orgId,
                            orgIdParam: event.data.orgIdParam,
                            appGroupId: event.data.deletedAppGroupId,
                        });
                    } else {
                        const appGroup = event.data.model as AppGroup;

                        connectedAppGroups.push({
                            orgId: event.data.orgId,
                            orgIdParam: event.data.orgIdParam,
                            appGroup,
                        });
                    }
                });

                if (connectedAppGroups.length > 0) {
                    yield put(appGroupsUpdated(connectedAppGroups));

                    if (process.env.NODE_ENV !== Environment.Production) {
                        const message =
                            connectedAppGroups.length > 1 ?
                                `${connectedAppGroups.length} app groups updated`
                            :   `App group ${connectedAppGroups[0].appGroup.name} updated`;

                        const notification = {
                            title: '📣 Websocket event',
                            message: message,
                        };

                        yield put(newNotification(notification));
                    }
                }

                if (deletedAppGroups.length > 0) {
                    yield put(appGroupsDeleted(deletedAppGroups));
                }

                break;
            }
            case ModelType.RolloutMonitoring: {
                const rolloutMonitoringResponses = [];
                for (const event of allModelTypeEvents) {
                    const releaseId = event.data.releaseId;
                    const orgId = event.data.orgId;
                    const appId = event.data.appId;

                    const rolloutMonitoring = event.data.model as RolloutMonitoring;

                    const rolloutMonitoringResponse: RolloutMonitoringResponse = {
                        rolloutMonitoring,
                        releaseId,
                        appId,
                        orgId,
                    };

                    rolloutMonitoringResponses.push(rolloutMonitoringResponse);
                }

                if (rolloutMonitoringResponses.length > 0) {
                    yield put(updateRolloutMonitoringForReleases(rolloutMonitoringResponses));
                }

                break;
            }
            case ModelType.FeatureFlags: {
                const featureFlagsResponses = [];
                for (const event of allModelTypeEvents) {
                    const releaseId = event.data.releaseId;

                    const featureFlags = event.data.model as FeatureFlag[];

                    const featureFlagsResponse: FetchFeatureFlagsResponse = {
                        featureFlags,
                        releaseId,
                    };

                    featureFlagsResponses.push(featureFlagsResponse);
                }

                if (featureFlagsResponses.length > 0) {
                    yield put(updateFeatureFlagsForReleases(featureFlagsResponses));
                }

                break;
            }
            case ModelType.BuildDistroBucket: {
                for (const event of allModelTypeEvents) {
                    const orgId = event.data.orgId;
                    const appId = event.data.appId;

                    const bucket = event.data.model as BuildDistroBucketBase;
                    if (bucket && bucket.id && orgId && appId) {
                        const response: UpdateBuildDistributionBucketSuccessResponse = {
                            bucket: {
                                ...bucket,
                                disallowedActions: null, // permissions cannot currently be updated via ws message
                            },
                            orgId,
                            appId,
                            bucketId: bucket.id,
                        };

                        yield put(updateDistributionBucketSuccess(response));
                    }
                }

                break;
            }
            case ModelType.BuildDistroBuild: {
                for (const event of allModelTypeEvents) {
                    const orgId = event.data.orgId;
                    const appId = event.data.appId;

                    const build = event.data.model as BuildDistroBuild;

                    const response: FetchBuildDistributionBucketBuildResponsePayload = {
                        build,
                        orgId,
                        appId,
                    };

                    yield put(fetchBuildDistributionBucketBuildSuccess(response));
                }

                break;
            }
            case ModelType.ReleaseStep: {
                const releaseSteps: ReleaseStep[] = [];
                for (const event of allModelTypeEvents) {
                    const releaseStep = event.data.model as ReleaseStep;
                    releaseSteps.push(releaseStep);
                }

                yield spawn(updateRunwayModelsSaga, {
                    releaseSteps,
                });

                break;
            }
            case ModelType.StepRun: {
                const stepRuns: StepRun[] = [];
                for (const event of allModelTypeEvents) {
                    const stepRun = event.data.model as StepRun;
                    stepRuns.push(stepRun);
                }

                yield spawn(updateRunwayModelsSaga, {
                    stepRuns,
                });

                break;
            }
        }
    }
}

export function selectPackageVersion() {
    return PACKAGE_VERSION;
}

export function* wsMessageSaga(action) {
    const payload = action.payload;
    const eventContainer: WebsocketEventContainer = JSON.parse(payload.message);

    const packageVersion = yield* call(selectPackageVersion);

    if (process.env.NODE_ENV !== Environment.Production) {
        console.log('Websocket message received with raw payload:');
        console.log(eventContainer);
    }

    // Display notfications first

    const notificationEvents = eventContainer.updates.filter(
        (event) => event.messageType === WebsocketMessageType.Notification,
    ) as WebsocketNotificationEvent[];

    if (notificationEvents.length > 0) {
        for (const event of notificationEvents) {
            const notification = event.data as Notification;

            yield put(newNotification(notification));
        }
    }

    // Updated state

    const stateUpdateEvents = eventContainer.updates.filter(
        (event) => event.messageType === WebsocketMessageType.StateUpdate,
    ) as WebsocketStateUpdateEvent[];

    const isAppsStateFetchedForApps = yield select(selectIsAppStateFetchedForApps);

    if (stateUpdateEvents.length > 0) {
        yield* call(handleStateUpdateEvents, stateUpdateEvents, isAppsStateFetchedForApps, packageVersion);
    }

    // New state

    const newStateEvents = eventContainer.updates.filter(
        (event) => event.messageType === WebsocketMessageType.NewState,
    ) as WebsocketNewStateEvent[];

    if (newStateEvents.length > 0) {
        for (const event of newStateEvents) {
            const payload = event.data as DashboardState;

            yield put(dashboardStateUpdatedFromWebsocket(payload));
        }
    }
}

export function* processAddedApps(
    response: CreateAppApiResponse[],
    orgId: string,
    orgIdParam: string,
    shouldRedirectToAddedApp = true,
) {
    const apps = response.map((apiResponse) => {
        return apiResponse.apps.map((app) => {
            return {
                orgId,
                orgIdParam,
                appGroupId: apiResponse.appGroup.id,
                app,
            };
        });
    });
    const connectedApps = flatten(apps);

    const connectedAppGroups = response.map((apiResponse) => {
        return {
            orgId,
            orgIdParam,
            appGroup: apiResponse.appGroup,
        };
    });

    const releases = response.map((apiResponse) => {
        return apiResponse.apps.map((app) => {
            return app.releases.map((release) => {
                return {
                    orgId,
                    orgIdParam,
                    appId: app.id,
                    appIdParam: app.appId,
                    release,
                };
            });
        });
    });

    const connectedReleases: ConnectedReleaseResponse[] = flattenDeep(releases);
    const connectedAppIdParams = connectedApps.map((connectedApp) => connectedApp.app.appId);

    yield put(appsAddedSuccess(connectedApps));
    yield put(appGroupsUpdated(connectedAppGroups));
    yield put(releasesUpdated(connectedReleases));

    if (shouldRedirectToAddedApp) {
        yield put(appsAddedShouldRedirect(connectedAppIdParams));
    }
}

export function* addAppsSaga(action: AddAppsAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);
        const responseArray: CreateAppApiResponse[] = yield* call(API.addApps, action.payload, auth);
        const orgId = action.payload.orgId;
        const orgIdParam = action.payload.orgIdParam;

        yield* call(processAddedApps, responseArray, orgId, orgIdParam);

        yield spawn(updated, action.type);

        yield* call(trackAddAppEvent, orgId, responseArray);
    } catch (error) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

export function* createAppSaga(action: CreateAppAction) {
    yield put(clearFailure(action.type));
    yield put(loadingActionStart(action.type));

    try {
        const auth = yield* call(getAuthCredentialsForSaga);
        const response: CreateAppApiResponse[] = yield* call(API.createApp, action.payload, auth);
        const orgId = action.payload.orgId;
        const orgIdParam = action.payload.orgIdParam;

        yield* call(processAddedApps, response, orgId, orgIdParam);

        yield spawn(updated, action.type);
    } catch (error) {
        yield spawn(failure, action.type, error.message);
    } finally {
        yield put(loadingStopAction(action.type));
    }
}

export function* deleteAppSaga(action: TryDeleteAppAction) {
    yield put(clearFailure(action.type, action.payload.appId));
    yield put(loadingActionStart(action.type, action.payload.appId));

    try {
        yield* call(verifyCanUpdateApp);

        const auth = yield* call(getAuthCredentialsForSaga);

        yield* call(API.deleteApp, action.payload, auth);

        yield* call(willUpdate, action.type, action.payload.appId);

        const deleteAppPayload: DeletedAppEntityPayload = {
            appId: action.payload.appId,
            orgId: action.payload.orgId,
            appGroupId: action.payload.appGroupId,
            orgIdParam: action.payload.orgIdParam,
        };

        yield spawn(updated, action.type, action.payload.appId);

        yield put(appsDeleted([deleteAppPayload]));
    } catch (error) {
        yield spawn(failure, action.type, error.message, action.payload.appId);
    } finally {
        yield put(loadingStopAction(action.type, action.payload.appId));
    }
}

const encodeSortInURL = (sortType: SortType, currentSearch: string) => {
    const searchParams = new URLSearchParams(currentSearch);

    searchParams.set('sort', sortType);

    // store the sort in local storage
    Storage.setFeatureItemsSortStoredParams(sortType);

    return searchParams.toString();
};

// eslint-disable-next-line require-yield
export function* updateFeatureItemsSortSaga(action: UpdateFeatureItemsSortAction) {
    const url = new URL(window.location.toString());
    url.search = encodeSortInURL(action.payload.sortType, window.location.search);
    window.history.pushState({}, '', url.toString());
}

const encodeFiltersInURL = (filters: AnyFilter[], currentSearch: string) => {
    const searchParams = new URLSearchParams(currentSearch);

    if (filters.length === 0) {
        searchParams.delete('filters');

        // clear the filters from local storage
        Storage.clearFeatureItemsFiltersStoredParams();

        return searchParams.toString();
    }

    const filtersJSON = JSON.stringify(filters);
    searchParams.set('filters', filtersJSON);

    // store the filters in local storage
    Storage.setFeatureItemsFiltersStoredParams(filtersJSON);

    return searchParams.toString();
};

// eslint-disable-next-line require-yield
export function* updateFeatureItemsFiltersSaga(action: UpdateFeatureItemsFiltersAction) {
    const url = new URL(window.location.toString());
    url.search = encodeFiltersInURL(action.payload.filters, window.location.search);
    window.history.pushState({}, '', url.toString());
}

export function* removeFeatureItemsFilterSaga(action: RemoveFeatureItemsFilterAction) {
    const currentFiltersState: AnyFilter[] = yield select(selectAppliedFilters);
    const itemToBeRemoved = action.payload;
    const newFilters = currentFiltersState?.filter((item) => !isEqual(item, itemToBeRemoved)) ?? [];
    const url = new URL(window.location.toString());
    url.search = encodeFiltersInURL(newFilters, window.location.search);
    window.history.pushState({}, '', url.toString());
}

const encodeShouldShowFixesOnlyInURL = (showFixesOnly: boolean, currentSearch: string) => {
    const searchParams = new URLSearchParams(currentSearch);

    if (showFixesOnly) {
        searchParams.set('showFixesOnly', 'true');

        // store the showFixesOnly in local storage
        Storage.setFeatureItemsOnlyFixesStoredParams('true');
    } else {
        searchParams.delete('showFixesOnly');

        // clear the showFixesOnly from local storage
        Storage.clearFeatureItemsOnlyFixesStoredParams();
    }

    return searchParams.toString();
};

// eslint-disable-next-line require-yield
export function* updateShowFixesOnlySaga(action: UpdateShowFixesOnlyAction) {
    const url = new URL(window.location.toString());
    url.search = encodeShouldShowFixesOnlyInURL(action.payload, window.location.search);
    window.history.pushState({}, '', url.toString());
}

function* getAuthCredentialsForSaga() {
    let auth = yield select(selectAuthCredentials);

    if (auth) {
        const authCredentialsExpiration = dayjs.unix(auth.expiry);
        // if auth credentials are expired fetch a new auth token
        if (authCredentialsExpiration.isBefore(dayjs())) {
            yield* call(refreshToken, auth.token);
            auth = yield select(selectAuthCredentials);
        }
    }

    return auth;
}

const encodeGroupWorkItemsByTicketInURL = (groupByTicket: boolean, currentSearch: string) => {
    const searchParams = new URLSearchParams(currentSearch);

    if (groupByTicket) {
        searchParams.set('groupWorkItemsByTicket', 'true');

        // store the groupByTicket in local storage
        Storage.setFeatureItemsGroupByTicketStoredParams('true');
    } else {
        searchParams.delete('groupWorkItemsByTicket');

        // clear the groupByTicket from local storage
        Storage.clearFeatureItemsGroupByTicketStoredParams();
    }

    return searchParams.toString();
};

// eslint-disable-next-line require-yield
export function* updateGroupWorkItemsByTicketSaga(action: UpdateGroupWorkItemsByTicketAction) {
    const url = new URL(window.location.toString());
    url.search = encodeGroupWorkItemsByTicketInURL(action.payload, window.location.search);
    window.history.pushState({}, '', url.toString());
}

function* watchCreateNewRelease() {
    yield takeEvery(TRY_NEW_RELEASE, createReleaseSaga);
}

function* watchCreateNewBuildDistributionBucket() {
    yield takeEvery(TRY_NEW_BUILD_DISTRIBUTION_BUCKET, createBuildDistributionBucketSaga);
}

function* watchShareBuildDistributionBuildWithTesters() {
    yield takeEvery(UPDATE_BUILD_DISTRIBUTION_BUILD_TESTERS, shareBuildDistributionBuildWithTestersSaga);
}

function* watchUpdateBuildDistributionBuildTesterNotes() {
    yield takeEvery(UPDATE_BUILD_DISTRIBUTION_BUILD_TESTER_NOTES, updateBuildDistributionBuildTesterNotesSaga);
}

function* watchArchiveBuildDistributionBuild() {
    yield takeEvery(ARCHIVE_BUILD_DISTRIBUTION_BUILD, archiveBuildDistributionBuildSaga);
}

function* watchTriggerBuildDistributionBuild() {
    yield takeEvery(TRIGGER_BUILD_DISTRIBUTION_BUILD, triggerBuildDistributionBuildSaga);
}

function* watchTriggerReleaseWorkflowBuild() {
    yield takeEvery(TRIGGER_RELEASE_WORKFLOW_BUILD, triggerReleaseWorkflowBuildSaga);
}

function* watchArchiveBuildDistributionBucket() {
    yield takeEvery(TRY_ARCHIVE_BUILD_DISTRIBUTION_BUCKET, archiveBuildDistributionBucketSaga);
}

function* watchUpdateBuildDistributionBucket() {
    yield takeEvery(AllBuildDistroUpdatableTypes, updateBuildDistributionBucketSaga);
}

function* watchSignUp() {
    yield takeEvery(UserUpdatable.TRY_SIGN_UP, signUpSaga);
}

function* watchLoginRequest() {
    yield takeEvery(TRY_LOGIN, loginSaga);
}

function* watchRefreshToken() {
    yield all([takeEvery(TRY_REFRESH_AUTH_TOKEN, refreshToken), takeEvery(TRY_SILENT_REFRESH_TOKEN, refreshToken)]);
}

function* watchNewIntegration() {
    yield takeLeading(AllAuthUpdatableTypes, createIntegrationSaga);
}

function* watchUpdateIntegration() {
    yield takeEvery(AllIntegrationUpdatableTypes, updateIntegrationSaga);
}

function* watchRefreshIntegration() {
    yield takeEvery(AllIntegrationRefreshableTypes, refreshIntegrationSaga);
}

function* watchDeleteIntegration() {
    yield takeEvery(AllIntegrationDeletableTypes, deleteIntegrationSaga);
}

function* watchUpdateDevices() {
    yield takeEvery(AllDevicesUpdatableTypes, updateDevicesSaga);
}

function* watchRefreshIntegrations() {
    yield takeEvery(TRY_REFRESH_INTEGRATIONS, refreshIntegrations);
}

function* watchDeleteRelease() {
    yield takeEvery(TRY_DELETE_RELEASE_ENTITY, deleteReleaseSaga);
}

function* watchUpdateRelease() {
    yield takeEvery(AllReleaseUpdatableTypes, updateReleaseSaga);
}

function* watchUpdateFeatureFlags() {
    yield takeEvery(AllFeatureFlagUpdatableTypes, updateFeatureFlagsSaga);
}

function* watchUpdateReleaseSteps() {
    yield takeEvery(AllReleaseStepUpdatableTypes, updateReleaseStepSaga);
}

function* watchUpdateChecklistItem() {
    yield takeEvery(AllChecklistItemUpdatableTypes, updateChecklistItemSaga);
}

function* watchUpdateAppSettings() {
    yield takeEvery(AllAppSettingsUpdatableTypes, updateAppSettingsSaga);
}

function* watchUpdateOrgSettings() {
    yield takeEvery(AllOrgSettingsUpdatableTypes, updateOrgSettingsSaga);
}

function* watchAddPublicApi() {
    yield takeEvery(AllPublicApiUpdatableTypes, addPublicApiSaga);
}

function* watchUpdateAppSettingsV2() {
    yield takeEvery(AllAppSettingsV2UpdatableTypes, updateAppSettingsV2Saga);
}

function* watchNewPassword() {
    yield takeEvery(UserUpdatable.TRY_NEW_PASSWORD, newPasswordSaga);
}

function* watchUpdateUserDevices() {
    yield takeEvery(UserUpdatable.UPDATE_USER_DEVICES, updateUserDevicesSaga);
}

function* watchUpdateUserEmailNotificationSettings() {
    yield takeEvery(UserUpdatable.UPDATE_USER_EMAIL_NOTIFICATION_SETTINGS, updateUserEmailNotificationsSaga);
}

function* watchUpdateUserShowSimplifiedBdUI() {
    yield takeEvery(UserUpdatable.UPDATE_SHOW_SIMPLIFIED_BD_UI, updateShouldShowSimplifiedBdUISaga);
}

function* watchVerifyCommsUser() {
    yield takeEvery(UserUpdatable.VERIFY_COMMS_USER, verifyCommsUserSaga);
}

function* watchLogout() {
    yield takeEvery(TRY_LOGOUT, logoutSaga);
}

function* watchUpdateReleaseEntity() {
    yield takeEvery(TRY_UPDATE_RELEASE_ENTITY, updateReleaseEntitySaga);
}

function* watchTryFetchState() {
    yield takeEvery([TRY_FETCH_STATE], fetchStateSaga);
}

function* watchSwitchOrgFetchState() {
    yield takeEvery([TRY_CHANGE_ORG_FETCH_STATE], switchOrgFetchState);
}

function* watchVerifyAuthCode() {
    yield takeEvery(TRY_VERIFY_AUTH_CODE, verifyAuthCodeSaga);
}

function* watchFetchEntity() {
    yield all([
        takeLatest(FetchableEntityType.AppState, fetchEntitySaga),
        takeLatest(FetchableEntityType.AppHome, fetchEntitySaga),
        takeLeading(FetchableEntityType.Release, fetchEntitySaga),
        takeLeading(FetchableEntityType.ReleaseStats, fetchEntitySaga),
        takeLeading(FetchableEntityType.GetReleaseOverview, fetchEntitySaga),
        takeLeading(FetchableEntityType.RolloutMonitoring, fetchEntitySaga),
        takeLeading(FetchableEntityType.FeatureFlags, fetchEntitySaga),
        takeLeading(FetchableEntityType.BuildDistributionBucketsWithRecentBuilds, fetchEntitySaga),
        takeLeading(FetchableEntityType.BuildDistributionBucket, fetchEntitySaga),
        takeLeading(FetchableEntityType.BuildDistributionBucketBuild, fetchEntitySaga),
        takeLeading(FetchableEntityType.ProvisioningProfiles, fetchEntitySaga),
        takeLeading(FetchableEntityType.BuildDistributionBucketDownloadMetrics, fetchEntitySaga),
        takeEvery(FetchableEntityType.ReleaseStep, fetchEntitySaga),
        takeEvery(FetchableEntityType.OrgOverviewV2, fetchEntitySaga), // spawns new saga for every request
        takeLeading(FetchableEntityType.OrgSummaryView, fetchEntitySaga),
        takeLeading(FetchableEntityType.OrgDestinationsAndVersions, fetchEntitySaga),
        takeEvery(FetchablePaginatedEntityType.Releases, fetchPaginatedEntitiesSaga),
        takeEvery(FetchablePaginatedEntityType.BuildDistributionBucketBuilds, fetchPaginatedEntitiesSaga),
        takeEvery(FetchablePaginatedEntityType.BuildDistributionSharedWithMeBuilds, fetchPaginatedEntitiesSaga),
        takeEvery(FetchablePaginatedEntityType.BuildDistributionBuildWorkItemsTimeline, fetchPaginatedEntitiesSaga),
        takeEvery(FetchablePaginatedEntityType.AllDevices, fetchPaginatedEntitiesSaga),
    ]);
}

function* watchFetchEntityV2() {
    yield all([
        yield takeLatest(FetchableEntityTypeV2.StepRun, fetchEntityV2Saga),
        yield takeLatest(FetchableEntityTypeV2.StepRunsSummary, fetchEntityV2Saga),
        yield takeLatest(FetchableEntityTypeV2.StepConfig, fetchEntityV2Saga),
        yield takeLatest(FetchableEntityTypeV2.WorkflowOverview, fetchEntityV2Saga),
        yield takeLatest(FetchableEntityTypeV2.OrgChecklistItemTemplates, fetchEntityV2Saga),
    ]);
}

function* watchRunwayUpdatable() {
    const effects = AllRunwayUpdatables.map((updatable) => {
        if (hasSupportForParallelism(updatable)) {
            return takeEvery(updatable, runwayUpdatableSaga);
        } else {
            return takeLatest(updatable, runwayUpdatableSaga);
        }
    });

    yield all(effects);
}

function* watchAddApps() {
    yield takeLeading(TRY_ADD_APPS, addAppsSaga);
}

function* watchCreateApp() {
    yield takeLeading(TRY_CREATE_APP, createAppSaga);
}

function* watchDeleteApp() {
    yield takeEvery(TRY_DELETE_APP_ENTITY, deleteAppSaga);
}

function* watchUpdateUserflowUser() {
    yield takeEvery(
        [NEW_RELEASE_SUCCESS, APPS_ADDED_SUCCESS, CREATE_INTEGRATION_REQUEST_SUCCESS, UPDATE_ORG_SETTINGS_SUCCESS],
        updateUserflowUser,
    );
}

function* watchGetAppConfig() {
    yield takeEvery([TRY_GET_APP_CONFIG, TRY_SILENT_GET_APP_CONFIG], getAppConfigSaga);
}

function* watchTrackingEvents() {
    yield all([
        takeLeading(TRACK_ORG_ROUTE_EVENT, trackOrgRouteEventSaga),
        takeLeading(TRACK_APP_ROUTE_EVENT, trackAppRouteEventSaga),
        takeLeading(TRACK_RELEASE_ROUTE_EVENT, trackReleaseRouteEventSaga),
        takeLeading(TRACK_BUILD_DISTRO_EVENT, trackBuildDistroEventSaga),
        takeLeading(TRACK_RELEASE_STEP_VIEW_EVENT, trackViewReleaseStepEventSaga),
        takeLeading(TRACK_USER_EVENT, trackUserEventSaga),
        takeLeading(TRACK_ONBOARDING_EVENT, trackOnboardingEventSaga),
        takeLeading(TRACK_QUICK_START_EVENT, trackQuickStartEventSaga),
    ]);
}

function* watchFRItemsURLParams() {
    yield takeEvery(UPDATE_FEATURE_ITEMS_SORT, updateFeatureItemsSortSaga);
    yield takeEvery(UPDATE_FEATURE_ITEMS_FILTERS, updateFeatureItemsFiltersSaga);
    yield takeEvery(REMOVE_FEATURE_ITEMS_FILTER, removeFeatureItemsFilterSaga);
    yield takeEvery(UPDATE_SHOW_FIXES_ONLY, updateShowFixesOnlySaga);
    yield takeEvery(UPDATE_GROUP_WORK_ITEMS_BY_TICKET, updateGroupWorkItemsByTicketSaga);
}

export function* rootSaga() {
    yield all([
        watchGetAppConfig(),
        watchLoginRequest(),
        watchRefreshToken(),
        watchUpdateUserflowUser(),
        WsEffects.watchWebsocketConnect(),
        WsEffects.watchWebsocketError(),
        WsEffects.watchWebsocketReconnect(),
        WsEffects.watchWebsocketOpen(),
        WsEffects.watchWebsocketClosed(),
        WsEffects.watchWebsocketMessage(),
        WsEffects.watchLogoutSuccess(),
        watchUpdateRelease(),
        watchUpdateFeatureFlags(),
        watchUpdateReleaseSteps(),
        watchUpdateChecklistItem(),
        watchUpdateAppSettings(),
        watchUpdateAppSettingsV2(),
        watchUpdateOrgSettings(),
        watchAddPublicApi(),
        watchNewIntegration(),
        watchUpdateIntegration(),
        watchRefreshIntegration(),
        watchUpdateDevices(),
        watchDeleteIntegration(),
        watchNewPassword(),
        watchUpdateUserDevices(),
        watchUpdateUserEmailNotificationSettings(),
        watchUpdateUserShowSimplifiedBdUI(),
        watchVerifyCommsUser(),
        watchCreateNewRelease(),
        watchCreateNewBuildDistributionBucket(),
        watchUpdateBuildDistributionBuildTesterNotes(),
        watchArchiveBuildDistributionBuild(),
        watchTriggerBuildDistributionBuild(),
        watchArchiveBuildDistributionBucket(),
        watchUpdateBuildDistributionBucket(),
        watchShareBuildDistributionBuildWithTesters(),
        watchLogout(),
        watchRefreshIntegrations(),
        watchUpdateReleaseEntity(),
        watchDeleteRelease(),
        watchTryFetchState(),
        watchVerifyAuthCode(),
        watchFetchEntity(),
        watchFetchEntityV2(),
        watchRunwayUpdatable(),
        watchAddApps(),
        watchCreateApp(),
        watchDeleteApp(),
        watchSignUp(),
        watchSwitchOrgFetchState(),
        watchFRItemsURLParams(),
        watchTrackingEvents(),
        watchTriggerReleaseWorkflowBuild(),
    ]);
}
